module.exports = Object.assign(require('./Construction.json'), {
    visibility: true,
    locked: false,
    image: '/img/workflows/Construction.png',
    defaultItems: {
        "CS542": 1
    },
    orderStatuses: require('../OrderStatuses.js'),
    tabs: [
        require('./Tab0-MasterData.js'),
        require('./Tab1-Scans.js'),
        // require('./Tab1-Construction.js'),
        require('./Tab2-Attachments.js'),
        require('./Tab3-Addons.js'),
        require('./Tab4-Cart.js'),
    ]
});
